import { Button, Dialog, Flex, Link, ModalLayout, tokens, Typography } from '@sapphire-react/core';
import { ChevronRight } from '@sapphire/icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function Disclaimer() {
  const [isDisclaimerOpen, setIsDisclaimerOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <Flex justifyContent={'center'} marginTop={tokens.size.spacingXl}>
      <Button
        size={'lg'}
        variant={'text'}
        iconAlign={'right'}
        icon={<ChevronRight />}
        onPress={() => {
          setIsDisclaimerOpen(true);
        }}
      >
        {t('disclaimer.heading')}
      </Button>
      <Dialog size={'lg'} onClose={() => setIsDisclaimerOpen(false)} isOpen={isDisclaimerOpen}>
        <ModalLayout
          header={<ModalLayout.Header heading={t('disclaimer.heading')} />}
          body={
            <ModalLayout.Body>
              <Typography.Body marginBottom={tokens.size.spacingSm}>{t('disclaimer.paragraph1')}</Typography.Body>
              <Typography.Body marginBottom={tokens.size.spacingSm}>
                {t('disclaimer.paragraph2')}{' '}
                <Link>
                  <a
                    href={'https://danskebank.se/privat/produkter/bolan/relaterat/aktuella-bolanerantor'}
                    target={'_blank'}
                  >
                    {t('disclaimer.link')}
                  </a>
                </Link>
              </Typography.Body>
              <Typography.Body marginBottom={tokens.size.spacingSm}>{t('disclaimer.paragraph3')}</Typography.Body>
              <Typography.Body marginBottom={tokens.size.spacingSm}>{t('disclaimer.paragraph4')}</Typography.Body>
              <Typography.Body marginBottom={tokens.size.spacingSm}>{t('disclaimer.paragraph5')}</Typography.Body>
              <Typography.Body marginBottom={tokens.size.spacingSm}>{t('disclaimer.paragraph6')}</Typography.Body>
              <Typography.Body marginBottom={tokens.size.spacingSm}>{t('disclaimer.paragraph7')}</Typography.Body>
              <Typography.Body marginBottom={tokens.size.spacingSm}>{t('disclaimer.paragraph8')}</Typography.Body>
              <Typography.Body>{t('disclaimer.paragraph9')}</Typography.Body>
            </ModalLayout.Body>
          }
        />
      </Dialog>
    </Flex>
  );
}
